import { render, staticRenderFns } from "./BlurCover.vue?vue&type=template&id=03247ac6&"
import script from "./BlurCover.vue?vue&type=script&lang=js&"
export * from "./BlurCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports